import {
  ListButton,
  Show,
  ShowBase,
  TopToolbar,
  useResourceContext,
  WithRecord,
} from "react-admin";

import { Box } from "@mui/material";
import { GoBackButton } from "./goBackButton";
import { RecordTitle } from "./recordTitle";
import { MyEditButton as EditButton } from "./myEditButton";
import { WithPermissions } from "../acl/withPermissions";
import { DebugDotJson } from "./debugDotJson";
import { Row } from "./row";
import { ShowNavigation } from "./showNavigation";
import { Column } from "./column";
import { useRenderCounter } from "./renderCounter";

const TitledWrapper = (props) => {
  return <Box sx={{ width: "100%" }}>{props.children}</Box>;
};

const ShowActions = ({ extraActions }) => (
  <TopToolbar>
    <ShowNavigation />
    <ListButton />
    <EditButton />
    {extraActions}
    <GoBackButton size="small" variant="text" />
  </TopToolbar>
);

const RecordData = ({ sx }) => {
  return (
    <WithRecord
      render={(record) => (
        <DebugDotJson
          className="RecordData"
          data={record}
          jsonProps={{ wrapperStyle: { maxHeight: "60vh" } }}
          sx={sx}
        />
      )}
    />
  );
};

export const RecordSummary = ({
  children,
  className,
  Component = Row,
  ...rest
}) => {
  return (
    <Component className={`RecordSummary ${className}`} {...rest}>
      {children}
      <RecordData />
    </Component>
  );
};

export const MyShow = ({
  labelField,
  className,
  sx,
  style,
  actions,
  extraActions,
  noHeaders,
  ...props
}) => {
  const resource = useResourceContext();
  useRenderCounter(`Show ${resource}`);
  actions = actions || <ShowActions extraActions={extraActions} />;
  const recordTitle = <RecordTitle labelField={labelField} actions={actions} />;
  const _sx = { width: "100%" };

  return (
    <WithPermissions action={"show"}>
      <Column
        sx={{ ..._sx, ...sx }}
        style={style}
        className={["TitledShowWrapper", "multi-sticky", className].join(" ")}
      >
        {!noHeaders && <ShowBase {...props}>{recordTitle}</ShowBase>}
        <Show
          component={TitledWrapper}
          className="TitledShow"
          actions={null}
          {...props}
        >
          {props.children}
        </Show>
      </Column>
    </WithPermissions>
  );
};
